import { Injectable } from '@angular/core';
import { AbstractContentfulStateService, IContentfulDatasourceType } from '@y42/contentful';
import { Entry } from 'contentful';
import { DatasourceCTypeModel } from './datasource-type.model';

@Injectable({
  providedIn: 'root',
})
export class DatasourceTypesContentfulService extends AbstractContentfulStateService<
  IContentfulDatasourceType,
  DatasourceCTypeModel
> {
  constructor() {
    super('datasourceType', 'fields.displayName', 1000, (c: Entry<IContentfulDatasourceType>) => {
      return {
        type: c.fields.type,
        displayName: c.fields.displayName,
        description: c.fields.description,
        logo: c.fields.logo?.fields.file.url || '',
        orderNo: c.fields.orderNo,
        availabilityLabel: c.fields.availabilityLabel,
        industry: c.fields.industry,
        color: c.fields.color,
        articleid: c.fields.articleid,
        articleidAuth: c.fields.articleidAuth,
        scheduleTime: c.fields.scheduleTime,
        documentationUrl: c.fields.documentationUrl,
        rawGuideUrl: c.fields.rawGuideUrl,
        isAirbyte: c.fields.isAirbyte,
        hasIncremental: c.fields.hasIncremental,
        pictureUrl: c.fields.pictureUrl,
        authTutorial: c.fields.authTutorial?.content[0]?.content[0]?.value,
        useNewTriggerEndpoint: c.fields.useNewTriggerEndpoint,
        hideV2unsupported: c.fields.hideV2unsupported ?? false,
      };
    });
  }
}
